var version = '1.32.0';
export default version;
